/** TODO: Replace with inview library once we decide on one. */
if (
	navigator.userAgent.includes('chrome-lighthouse') ||
	navigator.userAgent.includes('lighthouse')
) {
	const heroHomepage = document.querySelector('.block-hero-homepage');
	if (null !== heroHomepage) {
		heroHomepage.classList.add('inview');
	}
} else {
	document.addEventListener('DOMContentLoaded', () => {
		const heroHomepage = document.querySelector('.block-hero-homepage');
		if (null !== heroHomepage) {
			heroHomepage.classList.add('inview');
		}
	});
}
